import { EvComboboxOption } from '@evinced-private/ui-common';

import { ITenantMemberUser } from 'src/interfaces/TenantMember';

const INACTIVE_EMAIL_RECIPIENT_PREFIX = '[Inactive]';

export const getUserLabel = ({ name, surname, email }: ITenantMemberUser): string => {
	if (name && surname) {
		return `${name} ${surname} (${email})`;
	}
	return email;
};

export const getInactiveEmailRecipientLabel = (recipientLabel: string): string => {
	if (recipientLabel.startsWith(INACTIVE_EMAIL_RECIPIENT_PREFIX)) {
		return recipientLabel;
	}

	return `${INACTIVE_EMAIL_RECIPIENT_PREFIX} ${recipientLabel}`;
};

export const getEmailRecipientLabelWithoutInactivePrefix = (recipientLabel: string): string =>
	recipientLabel.startsWith(INACTIVE_EMAIL_RECIPIENT_PREFIX)
		? recipientLabel.slice(INACTIVE_EMAIL_RECIPIENT_PREFIX.length).trim()
		: recipientLabel;

export const mapUsersToOptions = (
	users: ITenantMemberUser[],
	disabledIds: Set<string>
): EvComboboxOption[] =>
	users.map((user) => ({
		label: getUserLabel(user),
		value: user.id,
		disabled: disabledIds.has(user.id)
	}));
